/**
 * @generated SignedSource<<b36081e55c67748adc0bddcc3047bbfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useLocationDetailRelayQuery$variables = {
  id: string;
};
export type useLocationDetailRelayQuery$data = {
  readonly getLocation: {
    readonly availableHardwareCount: number;
    readonly avgRentalsEndedPerUser: number | null | undefined;
    readonly avgRentalsStartedPerUser: number | null | undefined;
    readonly bannerId: string | null | undefined;
    readonly capacity: number | null | undefined;
    readonly configuration: string | null | undefined;
    readonly createdOn: any;
    readonly hardware: ReadonlyArray<{
      readonly batteryPercent: number | null | undefined;
      readonly batteryVoltage: number | null | undefined;
      readonly hardwareType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly imei: string | null | undefined;
      readonly isActive: boolean | null | undefined;
      readonly isAvailable: boolean | null | undefined;
      readonly isOnline: boolean | null | undefined;
      readonly label: string | null | undefined;
      readonly lastSeen: any | null | undefined;
      readonly mac: string | null | undefined;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
      readonly state: number | null | undefined;
      readonly vendorId: string | null | undefined;
      readonly vendorSerial: string | null | undefined;
    }>;
    readonly icon: {
      readonly approvedOn: any | null | undefined;
      readonly comment: string | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly iconId: string | null | undefined;
    readonly id: string;
    readonly lat: number | null | undefined;
    readonly lng: number | null | undefined;
    readonly maxReservations: number | null | undefined;
    readonly module: string | null | undefined;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly operatingHours: any | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly polygonCoordinates: ReadonlyArray<ReadonlyArray<number>> | null | undefined;
    readonly preventEndingRentals: boolean | null | undefined;
    readonly preventStartingRentals: boolean | null | undefined;
    readonly private: boolean | null | undefined;
    readonly radius: number | null | undefined;
    readonly rates: ReadonlyArray<{
      readonly activeOn: any | null | undefined;
      readonly archivedOn: any | null | undefined;
      readonly baseRate: number | null | undefined;
      readonly baseRateIncludedTime: number | null | undefined;
      readonly createdOn: any;
      readonly creditCardHold: number | null | undefined;
      readonly freeTime: number | null | undefined;
      readonly hidden: boolean | null | undefined;
      readonly id: string;
      readonly maxPeriods: number | null | undefined;
      readonly maxRentals: number | null | undefined;
      readonly membershipRequired: boolean;
      readonly minimumWalletDeposit: number | null | undefined;
      readonly name: string;
      readonly oldId: string | null | undefined;
      readonly periodDuration: number | null | undefined;
      readonly pricePerPeriod: number | null | undefined;
    }> | null | undefined;
    readonly rentalsEndedCount: number | null | undefined;
    readonly rentalsStartedCount: number | null | undefined;
    readonly reservations: boolean | null | undefined;
    readonly slowZoneSpeed: number | null | undefined;
    readonly state: number | null | undefined;
    readonly system: {
      readonly closeTimeInt: number | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly openTimeInt: number | null | undefined;
      readonly operatingHours: boolean | null | undefined;
      readonly timezone: string;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly totalHardwareCount: number;
    readonly totalRentableHardwareCount: number;
    readonly uniqueUsersEndedCount: number | null | undefined;
    readonly uniqueUsersStartedCount: number | null | undefined;
    readonly zoneType: string | null | undefined;
  } | null | undefined;
};
export type useLocationDetailRelayQuery = {
  response: useLocationDetailRelayQuery$data;
  variables: useLocationDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "operatingHours",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Location",
    "kind": "LinkedField",
    "name": "getLocation",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "configuration",
        "storageKey": null
      },
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lng",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "polygonCoordinates",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "radius",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zoneType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slowZoneSpeed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "capacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRentableHardwareCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxReservations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preventEndingRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preventStartingRentals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentalsStartedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rentalsEndedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgRentalsStartedPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avgRentalsEndedPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uniqueUsersStartedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uniqueUsersEndedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "private",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "module",
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bannerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openTimeInt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closeTimeInt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Rate",
        "kind": "LinkedField",
        "name": "rates",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baseRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baseRateIncludedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pricePerPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxPeriods",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxRentals",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creditCardHold",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumWalletDeposit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hidden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedOn",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "limit",
            "value": 100
          },
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              {
                "field": "NUMBER",
                "order": "ASC"
              }
            ]
          }
        ],
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "hardware",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mac",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imei",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAvailable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOnline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastSeen",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "batteryPercent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "batteryVoltage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vendorId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vendorSerial",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareType",
            "kind": "LinkedField",
            "name": "hardwareType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "hardware(limit:100,sort:[{\"field\":\"NUMBER\",\"order\":\"ASC\"}])"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLocationDetailRelayQuery",
    "selections": (v7/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLocationDetailRelayQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "d64a7dab2d7f8740062f9285c53f615c",
    "id": null,
    "metadata": {},
    "name": "useLocationDetailRelayQuery",
    "operationKind": "query",
    "text": "query useLocationDetailRelayQuery(\n  $id: ID!\n) {\n  getLocation(id: $id) {\n    id\n    oldId\n    name\n    state\n    configuration\n    createdOn\n    lat\n    lng\n    polygonCoordinates\n    radius\n    zoneType\n    slowZoneSpeed\n    capacity\n    availableHardwareCount\n    totalHardwareCount\n    totalRentableHardwareCount\n    reservations\n    maxReservations\n    preventEndingRentals\n    preventStartingRentals\n    rentalsStartedCount\n    rentalsEndedCount\n    avgRentalsStartedPerUser\n    avgRentalsEndedPerUser\n    uniqueUsersStartedCount\n    uniqueUsersEndedCount\n    private\n    module\n    operatingHours\n    bannerId\n    organizationId\n    systemId\n    systemOldId\n    system {\n      id\n      oldId\n      name\n      timezone\n      operatingHours\n      openTimeInt\n      closeTimeInt\n    }\n    iconId\n    icon {\n      id\n      oldId\n      name\n      type\n      approvedOn\n      comment\n    }\n    rates {\n      id\n      oldId\n      name\n      baseRate\n      baseRateIncludedTime\n      freeTime\n      pricePerPeriod\n      periodDuration\n      maxPeriods\n      maxRentals\n      creditCardHold\n      minimumWalletDeposit\n      membershipRequired\n      hidden\n      activeOn\n      archivedOn\n      createdOn\n    }\n    hardware(limit: 100, sort: [{field: NUMBER, order: ASC}]) {\n      id\n      oldId\n      number\n      label\n      mac\n      imei\n      state\n      isAvailable\n      isActive\n      isOnline\n      lastSeen\n      batteryPercent\n      batteryVoltage\n      vendorId\n      vendorSerial\n      hardwareType {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52f689621762ad5b92cf89b42d7b2ca2";

export default node;
